import DataSource from '../DataSource'

export const REQUEST_CHECK_LOGGED_IN = 'REQUEST_CHECK_LOGGED_IN'
export const REQUEST_GET_CUSTOMER = 'REQUEST_GET_CUSTOMER'
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'
export const SET_EXCHANGE_TOKEN = 'SET_EXCHANGE_TOKEN'
export const SET_REDIRECT_TO = 'SET_REDIRECT_TO'
export const CLEAR_REDIRECT_TO = 'CLEAR_REDIRECT_TO'
export const ACTION_LOGOUT = 'ACTION_LOGOUT'
export const SET_LAST_ACTIVE = 'SET_LAST_ACTIVE'

export const SET_VERIFIED_USER = 'SET_VERIFIED_USER'
export const RESET_VERIFIED_USER = 'RESET_VERIFIED_USER'

export const SET_ITEM_HIDDEN = 'SET_ITEM_HIDDEN'

export const SET_MFA_VALIDATED = "SET_MFA_VALIDATED"

export const SET_MODAL_SEEN = 'SET_MODAL_SEEN'

export const checkLoggedIn = () => dispatch => {
    DataSource.getData('/api/auth/checkLoggedIn', result => {
        dispatch({
            type: REQUEST_CHECK_LOGGED_IN,
            payload: result
        })
    })
}

export const getCustomer = () => dispatch => {
    DataSource.getData('/api/auth/getCustomer', result => {
        dispatch({
            type: REQUEST_GET_CUSTOMER,
            payload: result
        })
    })
}

export const setAccessToken = (token, persistLogin) => dispatch => {
    dispatch({
        type: SET_ACCESS_TOKEN,
        payload: {
		    token: token,
            persistLogin: persistLogin
        }
    })
}

export const setExchangeToken = (exchangeToken) => dispatch => {
    dispatch({
        type: SET_EXCHANGE_TOKEN,
        payload: {
            exchangeToken: exchangeToken
        }
    })
}

export const setMfaValidated = () => dispatch => {
    dispatch({
        type: SET_MFA_VALIDATED,
        payload: {
            mfaValidated: true
        }
    })
}

export const setRedirectTo = (pathname) => dispatch => {
    dispatch({
        type: SET_REDIRECT_TO,
        payload: pathname
    })
}

export const clearRedirectTo = () => dispatch => {
    dispatch({
        type: CLEAR_REDIRECT_TO,
        payload: {}
    })
}

export const logout = () => dispatch => {
    dispatch({
        type: ACTION_LOGOUT,
        payload: {}
    })
}

export const setVerifiedUser = token => dispatch => {
    dispatch({
        type: SET_VERIFIED_USER,
        payload: token
    })
}

export const resetVerifiedUser = () => dispatch => {
    dispatch({
        type: RESET_VERIFIED_USER,
        payload: {}
    })
}

export const setItemHidden = (customerId, itemKey) => dispatch => {
    dispatch({
        type: SET_ITEM_HIDDEN,
        payload: { customerId: customerId, itemKey: itemKey }
    })
}

export const setModalSeen = (customerId, modalId) => dispatch => {
    dispatch({
        type: SET_MODAL_SEEN,
        payload: { customerId: customerId, modalId: modalId }
    })
}



// WEBPACK FOOTER //
// ./resources/js/redux/actions.js